import createPersistedState from 'vuex-persistedstate';
import { onLCP, onFID, onCLS, onFCP, onTTFB } from 'web-vitals/attribution';
import { pushLog } from 'src/utils/pushLog';

export default async ({ store }) => {
  // window.setTimeout(() => {
  createPersistedState({
    paths: [
      // 'Menu',
      'Menu.userInfo',
      'Menu.loginParams',
      'Menu.token',
      'Menu.toLoginPath',
      'Menu.language',
      'Menu.accessStatus',
      'Menu.storeServes',
      'Menu.addressInfo',
      'Menu.scheduled',
      'Menu.countryCode',
      'Menu.countryName',
      'Menu.platVoucher',
      'Menu.showVoucherDialogList',
      'Menu.account'
      // 'Menu.fullDineInTableData',
      // 'prefetch.storeSEO'
    ],
  })(store);
  // }, 0);
  if (process.env.ENV !== 'production') {
    const vitalsName = {
      CLS: '累计位移偏移',
      FID: '首次输入延迟时间',
      LCP: '最大内容绘制时间',
      FCP: '首次内容绘制时间',
      TTFB: '等待时间',
    }
    const vitalsConsole = function (e) {
      console.log(vitalsName[e.name], e.value, e.rating, e);
      pushLog({
        key: 'vitals',
        text: `${e.id} : ${vitalsName[e.name]} ${e.value} ${e.rating}`,
        data: JSON.stringify(e)
      }, true)
    }
    onCLS(vitalsConsole);
    onFID(vitalsConsole);
    onLCP(vitalsConsole);
    onFCP(vitalsConsole);
    onTTFB(vitalsConsole);
  }
};
